/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import React from 'react'

import { Label } from '../presentation/Text'
import { useColors } from '../../packages/kiti/components/theme/_hooks/colors'
import FlexGrid from '../structure/FlexGrid'
import Separator from '../helpers/Separator'

const SIZES = {
  small: 0.7,
  normal: 1,
  large: 1.7
}

const Switch = ({ onChange, value, label, noMargin, size, disabled }) => {
  const colors = useColors()
  const circleSize = SIZES[size] || SIZES.normal
  const width = circleSize * 2.5
  const style = css`
    display: block;
    border-radius: ${circleSize}rem;
    padding: 2px;
    width: ${width}rem;
    min-width: ${width}rem;
    background-color: ${value ? colors.primary : colors.light3};
    display: flex;
    justify-content: ${value ? 'flex-end' : 'flex-start'};
    opacity: ${disabled ? 0.3 : 1};
    cursor: ${disabled && 'initial'};
    & > .circle {
      height: ${circleSize}rem;
      width: ${circleSize}rem;
      border-radius: ${circleSize}rem;
      background-color: ${colors.white};
    }
  `

  if (!!label)
    return (
      <SwitchWithLabel
        label={label}
        onChange={onChange}
        value={value}
        disabled={disabled}
        noMargin={noMargin}
        size={size}
      />
    )
  const onClick = disabled ? () => {} : () => onChange(!value)

  return (
    <a css={style} onClick={onClick} className="switch">
      <div className="circle" />
    </a>
  )
}

export const SwitchWithLabel = ({ label, noMargin, ...props }) => (
  <div className="switch-with-label">
    <FlexGrid justify="flex-start" align="center">
      <Switch {...props} />
      <Separator vertical weight={2} />
      <Label noMargin {...props}>
        {label}
      </Label>
    </FlexGrid>
    {!noMargin && <Separator weight={4} />}
  </div>
)

export default Switch
